/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orgs_SubInputs */

const th_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โรงเรียน สโมสร และสมาคม เปิดเพื่อแก้ไขโปรไฟล์หรือจัดการสมาชิก`)
};

const en_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schools, clubs and federations. Open one to edit its profile or manage who belongs to it.`)
};

const ja_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学校・クラブ・連盟。開くとプロフィールの編集や所属メンバーの管理ができます。`)
};

const zh_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学校、俱乐部与协会。打开其中一个即可编辑资料或管理成员。`)
};

const es_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centros, clubes y federaciones. Abre uno para editar su perfil o gestionar quién pertenece a él.`)
};

const pt_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolas, clubes e federações. Abra uma para editar o perfil ou gerenciar quem pertence a ela.`)
};

const id_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekolah, klub dan federasi. Buka salah satu untuk menyunting profilnya atau mengelola anggotanya.`)
};

const fr_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Établissements, clubs et fédérations. Ouvrez-en un pour modifier son profil ou gérer ses membres.`)
};

const tl_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga paaralan, klab at pederasyon. Buksan ang isa para baguhin ang profile nito o pamahalaan ang mga miyembro nito.`)
};

const vi_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trường học, câu lạc bộ và liên đoàn. Mở một mục để sửa hồ sơ hoặc quản lý thành viên.`)
};

const ko_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`학교, 클럽, 연맹. 하나를 열어 프로필을 수정하거나 구성원을 관리하세요.`)
};

const de_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schulen, Vereine und Verbände. Öffne eine, um ihr Profil zu bearbeiten oder ihre Mitglieder zu verwalten.`)
};

const ru_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Школы, клубы и федерации. Откройте одну, чтобы изменить её профиль или управлять участниками.`)
};

const tr_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okullar, kulüpler ve federasyonlar. Profilini düzenlemek ya da üyelerini yönetmek için birini açın.`)
};

const it_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scuole, club e federazioni. Aprine una per modificarne il profilo o gestirne i membri.`)
};

const pl_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szkoły, kluby i federacje. Otwórz jedną, aby edytować jej profil albo zarządzać członkami.`)
};

const uk_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Школи, клуби та федерації. Відкрийте одну, щоб змінити її профіль або керувати учасниками.`)
};

const hi_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कूल, क्लब और महासंघ। प्रोफ़ाइल बदलने या सदस्यों को प्रबंधित करने के लिए कोई एक खोलें।`)
};

const ar_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدارس وأندية واتحادات. افتح إحداها لتعديل ملفها أو إدارة أعضائها.`)
};

const ms_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekolah, kelab dan persekutuan. Buka satu untuk menyunting profilnya atau mengurus ahlinya.`)
};

const bn_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কুল, ক্লাব ও ফেডারেশন। প্রোফাইল সম্পাদনা বা সদস্য পরিচালনার জন্য একটি খুলুন।`)
};

const zh_tw2_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`學校、俱樂部與協會。開啟其中一個即可編輯資料或管理成員。`)
};

const zh_hk2_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`學校、俱樂部與協會。開啟其中一個即可編輯資料或管理成員。`)
};

const ur_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکول، کلب اور فیڈریشن۔ پروفائل بدلنے یا ارکان سنبھالنے کے لیے کوئی ایک کھولیں۔`)
};

const fa_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدرسه‌ها، باشگاه‌ها و فدراسیون‌ها. یکی را باز کنید تا نمایه‌اش را ویرایش یا اعضایش را اداره کنید.`)
};

const sw_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shule, vilabu na shirikisho. Fungua moja ili kuhariri wasifu wake au kusimamia wanachama wake.`)
};

const nl_orgs_sub = /** @type {(inputs: Orgs_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scholen, clubs en bonden. Open er een om het profiel te bewerken of de leden te beheren.`)
};

/**
* | output |
* | --- |
* | "Schools, clubs and federations. Open one to edit its profile or manage who belongs to it." |
*
* @param {Orgs_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const orgs_sub = /** @type {((inputs?: Orgs_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orgs_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_orgs_sub(inputs)
	if (locale === "ja") return ja_orgs_sub(inputs)
	if (locale === "zh") return zh_orgs_sub(inputs)
	if (locale === "es") return es_orgs_sub(inputs)
	if (locale === "pt") return pt_orgs_sub(inputs)
	if (locale === "id") return id_orgs_sub(inputs)
	if (locale === "fr") return fr_orgs_sub(inputs)
	if (locale === "tl") return tl_orgs_sub(inputs)
	if (locale === "vi") return vi_orgs_sub(inputs)
	if (locale === "ko") return ko_orgs_sub(inputs)
	if (locale === "de") return de_orgs_sub(inputs)
	if (locale === "ru") return ru_orgs_sub(inputs)
	if (locale === "tr") return tr_orgs_sub(inputs)
	if (locale === "it") return it_orgs_sub(inputs)
	if (locale === "pl") return pl_orgs_sub(inputs)
	if (locale === "uk") return uk_orgs_sub(inputs)
	if (locale === "hi") return hi_orgs_sub(inputs)
	if (locale === "ar") return ar_orgs_sub(inputs)
	if (locale === "ms") return ms_orgs_sub(inputs)
	if (locale === "bn") return bn_orgs_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_orgs_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_orgs_sub(inputs)
	if (locale === "ur") return ur_orgs_sub(inputs)
	if (locale === "fa") return fa_orgs_sub(inputs)
	if (locale === "sw") return sw_orgs_sub(inputs)
	if (locale === "nl") return nl_orgs_sub(inputs)
	return en_orgs_sub(inputs)
});